// extracted by mini-css-extract-plugin
export default {"div":"MultiLanguage_div__mOTT+","triangle":"MultiLanguage_triangle__5zXGG","popup":"MultiLanguage_popup__FbJbF","separator":"MultiLanguage_separator__Fx1Ht"};